var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "root" } },
    [
      _c("Header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main d-flex" },
        [
          _c("notifications", {
            staticStyle: {
              width: "300px",
              top: "20px",
              right: "5px",
              color: "rgba(122, 184, 0, 1)"
            },
            attrs: { group: "ConfigTool", classes: "config-notification" }
          }),
          _vm._v(" "),
          _c("router-view")
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }